import onetime from "@-/com.npmjs.onetime";
import { createMMKV } from "@-/com.npmjs.react-native-mmkv";

export const getStorage = onetime(() => createMMKV());
